
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import TranslationItemModel from "@models/translationItemModel";
import { DragLiModel } from "./models";

@Component
export default class UiDragLiComponent extends Vue {
  @Prop() data: DragLiModel;

  showTranslations: boolean = false;
  primaryLanguageCodes: string[] = ["ru", "en", "ro"];

  get translations(): TranslationItemModel[] {
    return this.data?.Translate || [];
  }

  get primaryTranslations(): TranslationItemModel[] {
    return this.primaryLanguageCodes
      .map((langCode) =>
        this.translations.find(
          (translation) =>
            (translation.langCode || "").toLocaleLowerCase() === langCode
        )
      )
      .filter((translation) => !!translation);
  }

  get additionalTranslations(): TranslationItemModel[] {
    return this.translations.filter(
      (translation) =>
        !this.primaryLanguageCodes.includes(
          (translation.langCode || "").toLocaleLowerCase()
        )
    );
  }

  languageWord(count: number): string {
    const lastTwoDigits = count % 100;
    const lastDigit = count % 10;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) return "языков";
    if (lastDigit === 1) return "язык";
    if (lastDigit >= 2 && lastDigit <= 4) return "языка";
    return "языков";
  }

  created() {}

  mounted() {}
}
